import {trackPromise} from "react-promise-tracker";
import Call from "../../service/axios";
import {getUrl} from "../../constants/urls";

export const getAlerts = (pageUrl) => {
  const url = pageUrl ? pageUrl : getUrl("getAlertsList");
  return trackPromise(Call.get(url));
};

export const getSensorAlerts = (pageUrl) => {
  const url = pageUrl ? pageUrl : getUrl("getSensorAlertsList");
  return trackPromise(Call.get(url));
};

export const deleteAlert = (id = "") => {
  const url = getUrl("getAlertsList");
  const patchUrl = `${url}${id}/`;
  return trackPromise(Call.delete(patchUrl));
};

export const deleteSensorAlert = (id = "") => {
  const url = getUrl("getSensorAlertsList");
  const patchUrl = `${url}${id}/`;
  return trackPromise(Call.delete(patchUrl));
};

export const toggleAlert = ({id, requestData}) => {
  const url = getUrl("getAlertsList");
  const patchUrl = `${url}${id}/status/`;
  return trackPromise(Call.post(patchUrl, requestData));
};

export const toggleSensorAlert = ({id, requestData}) => {
  const url = getUrl("getSensorAlertsList");
  const patchUrl = `${url}${id}/status/`;
  return trackPromise(Call.post(patchUrl, requestData));
};

export const getDownTimeOptions = () => {
  const url = getUrl("downtimeCreateData");
  return trackPromise(Call.get(url));
};

export const getMetricOptions = () => {
  const url = getUrl("metricCreateData");
  return trackPromise(Call.get(url));
};

export const getMetricFieldOptions = ({data}) => {
  const url = getUrl("metricFieldOptions");
  return trackPromise(Call.post(url, data));
};

export const createDowntime = ({data, id}) => {
  const url = getUrl("createDowntime");
  if (id) {
    let patchUrl = `${url}${id}/`;
    return trackPromise(Call.patch(patchUrl, data));
  } else {
    return trackPromise(Call.post(url, data));
  }
};

export const createSensorDowntime = ({data, id}) => {
  const url = getUrl("createSensorDowntime");
  if (id) {
    let patchUrl = `${url}${id}/`;
    return trackPromise(Call.patch(patchUrl, data));
  } else {
    return trackPromise(Call.post(url, data));
  }
};

export const createMetric = ({data, id}) => {
  const url = getUrl("createMetric");
  if (id) {
    let patchUrl = `${url}${id}/`;
    return trackPromise(Call.patch(patchUrl, data));
  } else {
    return trackPromise(Call.post(url, data));
  }
};

export const getDowntimeGraphData = (payload) => {
  const url = getUrl("downtimeGraph");
  return trackPromise(Call.post(url, payload));
};

export const getSensorDowntimeGraphData = (payload) => {
  const url = getUrl("sensorDowntimeGraph");
  return trackPromise(Call.post(url, payload));
};

export const getSensorsListData = (payload) => {
  const url = getUrl("getSensorAlertsOptions");
  return trackPromise(Call.post(url, payload));
};

export const getMetricGraphData = (payload) => {
  const url = getUrl("metricGraph");
  return trackPromise(Call.post(url, payload));
};

export const getAlertHistoryAsync = (id) => {
  const url = getUrl("getAlertHistory")(id);
  return trackPromise(Call.get(url));
};

export const getSensorAlertHistoryAsync = (id) => {
  const url = getUrl("getSensorAlertHistory")(id);
  return trackPromise(Call.get(url));
};

export const getAlertHistoryLogsAsync = (id) => {
  const url = getUrl("getAlertHistoryLogs")(id);
  return trackPromise(Call.get(url));
};

export const getSensorAlertHistoryLogsAsync = (id) => {
  const url = getUrl("getSensorAlertHistoryLogs")(id);
  return trackPromise(Call.get(url));
};

export const handleAlertHandoffAsync = (payload = {}) => {
  const {alert, users} = payload;
  const url = getUrl("alertHandoff")(alert);
  return trackPromise(Call.post(url, {users}));
};

export const handleSensorAlertHandoffAsync = (payload = {}) => {
  const {alert, users} = payload;
  const url = getUrl("sensorAlertHandoff")(alert);
  return trackPromise(Call.post(url, {users}));
};
